import { setAlpha } from '../../../design-tokens';
import { renderDesignTokens } from '../../../theme';
export const getCalendarDesignTokens = (dt, opts) => {
  return {
    ...renderDesignTokens({
      'row-gap': dt.tokens['space-base-xs'],
      'col-gap': dt.tokens['space-base-s'],
      'header-row-gap': dt.tokens['space-base-m'],
      'font-size-xxs': dt.tokens['font-size-body-text-xxs'],
      'font-size-s': dt.tokens['font-size-body-text-s'],
      'font-size-m': dt.tokens['font-size-body-text-m'],
      'font-weight': dt.tokens['font-style-weight-400'],
      'line-height': dt.tokens['font-space-line-height'],
      'calendar-row-template': `repeat(${opts?.showTodayButton ? opts?.formatedCalendar.length : 7}, 1.5rem)`,
      'today-button-row-template': `repeat(${opts?.showLegend ? 1 : 7 - opts?.formatedCalendar.length}, 1.5rem)`,
      'focus-outline-offset': 'calc(-1px + var(--focus-width) * -1)'
    }, 'calendar-cell'),
    ...renderDesignTokens({
      bg: dt.tokens['color-action-background-subtle-normal'],
      bd: dt.tokens['color-action-border-subtle-normal'],
      fg: dt.tokens['color-action-text-subtle-normal']
    }, 'day-cell-normal'),
    ...renderDesignTokens({
      bg: dt.tokens['color-action-background-standard-hover'],
      fg: dt.tokens['color-action-text-standard-hover']
    }, 'day-cell-hover'),
    ...renderDesignTokens({
      bg: dt.tokens['color-action-background-standard-selected'],
      bd: dt.tokens['color-action-border-standard-selected'],
      fg: dt.tokens['color-action-text-standard-selected']
    }, 'day-cell-selected'),
    ...renderDesignTokens({
      bg: dt.stateStandardContentNova.disabled,
      bd: dt.tokens['color-action-border-subtle-disabled'],
      fg: dt.tokens['color-action-text-subtle-disabled']
    }, 'day-cell-external'),
    ...renderDesignTokens({
      pd: `${dt.tokens['space-base-xxs']} ${dt.tokens['space-base-xs']}`
    }, 'day-cell'),
    ...renderDesignTokens({
      outline: dt.themeVariant === 'high-contrast' ? 'var(--focus-dark-bg)' : 'var(--focus-light-bg)'
    }, 'day-cell-selected-focus'),
    ...renderDesignTokens({
      outline: 'var(--focus-light-bg)'
    }, 'day-cell-interval-focus'),
    ...renderDesignTokens({
      bd: dt.tokens['color-primary'],
      fg: dt.tokens['color-text-primary'],
      bg: 'transparent'
    }, 'day-cell-today'),
    ...renderDesignTokens({
      fg: dt.tokens['color-action-text-subtle-normal'],
      'col-grid-gap': dt.tokens['space-base-null']
    }, 'weekday'),
    ...renderDesignTokens({
      'font-size': dt.tokens['font-size-body-text-s'],
      'font-weight': dt.tokens['font-style-weight-400'],
      fg: dt.tokens['color-label-text'],
      pd: `${dt.tokens['space-base-xxs']} ${dt.tokens['space-base-xs']}`
    }, 'week-number-cell'),
    ...renderDesignTokens({
      bg: dt.tokens['color-container-border-4'],
      bw: dt.tokens['size-border-width-s']
    }, 'calendar-divider'),
    ...renderDesignTokens({
      bg: dt.tokens['color-action-background-subtle-selected-inactive'],
      bd: dt.tokens['color-action-border-subtle-selected-inactive'],
      fg: dt.tokens['color-action-text-subtle-selected-inactive']
    }, 'day-cell-interval'),
    ...renderDesignTokens({
      fg: dt.tokens['color-body-text']
    }, 'special-day'),
    ...renderDesignTokens({
      bg: setAlpha(dt.tokens['color-neutral'], 0.08),
      fg: dt.tokens['color-action-text-subtle-normal'],
      bd: dt.themeVariant === 'high-contrast' ? dt.tokens['color-body-text'] : 'transparent'
    }, 'non-work-day'),
    ...renderDesignTokens({
      'legend-gap': dt.tokens['space-base-m'],
      'font-size-s': dt.tokens['font-size-body-text-s'],
      'font-size-m': dt.tokens['font-size-body-text-m']
    }, 'calendar-legend'),
    ...(!dt.enableNovaTokens && getCalendarLegacyDesignTokens(dt))
  };
};
export const getCalendarLegacyDesignTokens = dt => {
  let weekday, dayCellToday, calendarDivider, dayCellInterval, specialDay, nonWorkDay;
  switch (dt.themeVariant) {
    case 'dark':
      weekday = {
        fg: dt.c.white80
      };
      dayCellToday = {
        fg: dt.c.p2,
        bg: 'transparent',
        bd: dt.c.p
      };
      calendarDivider = {
        bg: dt.c.white15
      };
      dayCellInterval = {
        fg: dt.c.white,
        bg: 'transparent',
        bd: dt.reportTokens.stateSecondary.selected.bd
      };
      specialDay = {
        fg: dt.c.white80
      };
      nonWorkDay = {
        bg: dt.reportTokens.stateStandard.normal.bg,
        bd: 'transparent'
      };
      break;
    case 'high-contrast':
    default:
      weekday = {
        fg: dt.c.n_1
      };
      dayCellToday = {
        fg: dt.c.p,
        bg: 'transparent',
        bd: dt.c.p
      };
      calendarDivider = {
        bg: dt.c.n3
      };
      dayCellInterval = {
        fg: dt.themeVariant === 'high-contrast' ? dt.c.white : dt.reportTokens.stateSecondary.selected.fg,
        bg: dt.themeVariant === 'high-contrast' ? 'transparent' : dt.reportTokens.stateSecondary.selected.bg,
        bd: dt.themeVariant === 'high-contrast' ? dt.reportTokens.stateSecondary.selected.bd : 'transparent'
      };
      specialDay = {
        fg: dt.c.n_1
      };
      nonWorkDay = {
        bg: dt.reportTokens.stateStandard.normal.bg,
        bd: dt.themeVariant === 'high-contrast' ? dt.tokens['color-body-text'] : 'transparent'
      };
      break;
  }
  return {
    ...renderDesignTokens({
      'font-size-xxs': dt.reportTokens.font.size.xxs,
      'font-size-s': dt.reportTokens.font.size.s,
      'font-size-m': dt.reportTokens.font.size.m,
      'font-weight': dt.reportTokens.font.weight.thick
    }, 'calendar-cell'),
    ...renderDesignTokens(dt.reportTokens.stateStandardContent.normal, 'day-cell-normal'),
    ...renderDesignTokens(dt.reportTokens.stateStandardContent.hover, 'day-cell-hover'),
    ...renderDesignTokens(dt.reportTokens.stateStandardContent.disabled, 'day-cell-external'),
    ...renderDesignTokens(dt.reportTokens.stateSecondary.selected, 'day-cell-selected'),
    ...renderDesignTokens(dayCellToday, 'day-cell-today'),
    ...renderDesignTokens(weekday, 'weekday'),
    ...renderDesignTokens(calendarDivider, 'calendar-divider'),
    ...renderDesignTokens(dayCellInterval, 'day-cell-interval'),
    ...renderDesignTokens(specialDay, 'special-day'),
    ...renderDesignTokens(nonWorkDay, 'non-work-day'),
    ...renderDesignTokens({
      'font-size-s': dt.reportTokens.font.size.s,
      'font-size-m': dt.reportTokens.font.size.m
    }, 'calendar-legend')
  };
};
//# sourceMappingURL=types.js.map